import _objectWithoutProperties from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _styled3 from "styled-components";
import _styled2 from "styled-components";
import _styled from "styled-components";
var _excluded = ["children", "variant"],
  _excluded2 = ["children", "variant"],
  _excluded3 = ["label", "msgs", "htmlFor"],
  _excluded4 = ["label", "msgs", "htmlFor"],
  _excluded5 = ["label", "msgs", "htmlFor"],
  _excluded6 = ["label", "msgs", "htmlFor"],
  _excluded7 = ["label", "msgs", "htmlFor"],
  _excluded8 = ["htmlFor", "msgs", "children"],
  _excluded9 = ["htmlFor", "children"],
  _excluded10 = ["htmlFor", "children"];
import React from "react";
import { Composition } from "atomic-layout";
import { CheckCircle } from "@styled-icons/boxicons-solid/CheckCircle";
import { ErrorCircle } from "@styled-icons/boxicons-solid/ErrorCircle";
import { Error } from "@styled-icons/boxicons-solid/Error";
import { colors } from "../shared/styles";
import { Input, TextArea, Password, UISelect, Checkbox, Radio, Label, OtherLabel, DatePicker, Switch } from "../Input";
export var FormGroup = function FormGroup(props) {
  return /*#__PURE__*/React.createElement(Composition, Object.assign({
    autoFlow: props.horizontal ? "column" : "row",
    gap: 8
  }, props));
};
var getVariantColor = function getVariantColor(variant) {
  return function (props) {
    switch (variant) {
      case "success":
        return colors.secondaryGreen;
      case "error":
        return colors.secondaryRed;
      case "warning":
        return colors.secondaryYellow;
      default:
        return undefined;
    }
  };
};
var getVariantIcon = function getVariantIcon(variant) {
  switch (variant) {
    case "success":
      return /*#__PURE__*/React.createElement(CheckCircle, {
        size: 16
      });
    case "error":
      return /*#__PURE__*/React.createElement(Error, {
        size: 16
      });
    case "warning":
      return /*#__PURE__*/React.createElement(ErrorCircle, {
        size: 16
      });
    default:
      return null;
  }
};
export var FormMessage = function FormMessage(_ref) {
  var children = _ref.children,
    variant = _ref.variant,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(_StyledDiv, Object.assign({}, props, {
    $_css: getVariantColor(variant),
    $_css2: getVariantColor(variant),
    $_css3: colors.plain
  }), getVariantIcon(variant), /*#__PURE__*/React.createElement(_StyledSpan, null, children));
};
export var InputMessage = React.forwardRef(function (_ref2, ref) {
  var children = _ref2.children,
    variant = _ref2.variant,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(_StyledDiv2, Object.assign({
    ref: ref
  }, props, {
    $_css4: getVariantColor(variant)
  }), getVariantIcon(variant), children);
});
export var FormInput = React.forwardRef(function (_ref3, ref) {
  var label = _ref3.label,
    msgs = _ref3.msgs,
    htmlFor = _ref3.htmlFor,
    props = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(FormGroup, null, label !== "" && label !== undefined && /*#__PURE__*/React.createElement(Label, {
    htmlFor: htmlFor !== null && htmlFor !== void 0 ? htmlFor : props.id
  }, label), /*#__PURE__*/React.createElement(Input, Object.assign({}, props, {
    ref: ref
  })), msgs === null || msgs === void 0 ? void 0 : msgs.map(function (msg, key) {
    if (msg !== undefined) {
      return /*#__PURE__*/React.createElement(InputMessage, {
        key: key,
        variant: msg.type
      }, msg.message);
    }
  }));
});
export var FormTextArea = React.forwardRef(function (_ref4, ref) {
  var label = _ref4.label,
    msgs = _ref4.msgs,
    htmlFor = _ref4.htmlFor,
    props = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/React.createElement(FormGroup, null, label !== "" && label !== undefined && /*#__PURE__*/React.createElement(Label, {
    htmlFor: htmlFor !== null && htmlFor !== void 0 ? htmlFor : props.id
  }, label), /*#__PURE__*/React.createElement(TextArea, Object.assign({}, props, {
    ref: ref
  })), msgs === null || msgs === void 0 ? void 0 : msgs.map(function (msg, key) {
    if (msg !== undefined) {
      return /*#__PURE__*/React.createElement(InputMessage, {
        key: key,
        variant: msg.type
      }, msg.message);
    }
  }));
});
export var FormPassword = React.forwardRef(function (_ref5, ref) {
  var label = _ref5.label,
    msgs = _ref5.msgs,
    htmlFor = _ref5.htmlFor,
    props = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/React.createElement(FormGroup, null, label !== "" && label !== undefined && /*#__PURE__*/React.createElement(Label, {
    htmlFor: htmlFor !== null && htmlFor !== void 0 ? htmlFor : props.id
  }, label), /*#__PURE__*/React.createElement(Password, Object.assign({}, props, {
    ref: ref
  })), msgs === null || msgs === void 0 ? void 0 : msgs.map(function (msg, key) {
    if (msg !== undefined) {
      return /*#__PURE__*/React.createElement(InputMessage, {
        key: key,
        variant: msg.type
      }, msg.message);
    }
  }));
});
export var FormSelect = React.forwardRef(function (_ref6, ref) {
  var label = _ref6.label,
    msgs = _ref6.msgs,
    htmlFor = _ref6.htmlFor,
    props = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/React.createElement(FormGroup, null, label !== "" && label !== undefined && /*#__PURE__*/React.createElement(Label, {
    htmlFor: htmlFor !== null && htmlFor !== void 0 ? htmlFor : props.id
  }, label), /*#__PURE__*/React.createElement(UISelect, Object.assign({}, props, {
    ref: ref
  })), msgs === null || msgs === void 0 ? void 0 : msgs.map(function (msg, key) {
    if (msg !== undefined) {
      return /*#__PURE__*/React.createElement(InputMessage, {
        key: key,
        variant: msg.type
      }, msg.message);
    }
  }));
});
export var FormDatePicker = React.forwardRef(function (_ref7, ref) {
  var label = _ref7.label,
    msgs = _ref7.msgs,
    htmlFor = _ref7.htmlFor,
    props = _objectWithoutProperties(_ref7, _excluded7);
  return /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
    htmlFor: htmlFor !== null && htmlFor !== void 0 ? htmlFor : props.id
  }, label), /*#__PURE__*/React.createElement(DatePicker, Object.assign({}, props, {
    ref: ref
  })), msgs === null || msgs === void 0 ? void 0 : msgs.map(function (msg, key) {
    if (msg !== undefined) {
      return /*#__PURE__*/React.createElement(InputMessage, {
        key: key,
        variant: msg.type
      }, msg.message);
    }
  }));
});
export var FormCheckbox = React.forwardRef(function (_ref8, ref) {
  var htmlFor = _ref8.htmlFor,
    msgs = _ref8.msgs,
    children = _ref8.children,
    props = _objectWithoutProperties(_ref8, _excluded8);
  return /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(OtherLabel, {
    htmlFor: htmlFor !== null && htmlFor !== void 0 ? htmlFor : props.id
  }, /*#__PURE__*/React.createElement(Checkbox, Object.assign({}, props, {
    ref: ref
  })), children), msgs === null || msgs === void 0 ? void 0 : msgs.map(function (msg, key) {
    if (msg !== undefined) {
      return /*#__PURE__*/React.createElement(InputMessage, {
        key: key,
        variant: msg.type
      }, msg.message);
    }
  }));
});
export var FormSwitch = React.forwardRef(function (_ref9, ref) {
  var htmlFor = _ref9.htmlFor,
    children = _ref9.children,
    props = _objectWithoutProperties(_ref9, _excluded9);
  return /*#__PURE__*/React.createElement(OtherLabel, {
    htmlFor: htmlFor !== null && htmlFor !== void 0 ? htmlFor : props.id
  }, /*#__PURE__*/React.createElement(Switch, Object.assign({}, props, {
    ref: ref
  })), children);
});
export var FormRadio = React.forwardRef(function (_ref10, ref) {
  var htmlFor = _ref10.htmlFor,
    children = _ref10.children,
    props = _objectWithoutProperties(_ref10, _excluded10);
  return /*#__PURE__*/React.createElement(OtherLabel, {
    htmlFor: htmlFor !== null && htmlFor !== void 0 ? htmlFor : props.id
  }, /*#__PURE__*/React.createElement(Radio, Object.assign({}, props, {
    ref: ref
  })), children);
});
var _StyledDiv = _styled("div").withConfig({
  displayName: "Form___StyledDiv",
  componentId: "sc-1fb0mn-0"
})(["display:block;border:1px solid ", ";color:", ";background-color:", ";font-size:12px;padding:14px;padding-left:40px;text-align:left;margin-bottom:20px;line-height:16px;& > svg{position:absolute;margin-left:-30px;}"], function (p) {
  return p.$_css;
}, function (p) {
  return p.$_css2;
}, function (p) {
  return p.$_css3;
});
var _StyledSpan = _styled("span").withConfig({
  displayName: "Form___StyledSpan",
  componentId: "sc-1fb0mn-1"
})(["vertical-align:top;"]);
var _StyledDiv2 = _styled("div").withConfig({
  displayName: "Form___StyledDiv2",
  componentId: "sc-1fb0mn-2"
})(["display:flex;font-size:12px;line-height:16px;svg{margin-right:4px;}color:", ";"], function (p) {
  return p.$_css4;
});